import React from 'react';
import {Button, Grid, Input, Modal, Segment} from 'semantic-ui-react';
import _ from "lodash";
import {socket} from "../../../lib/socketio";
import {isAuthorized } from '../../../lib/authorization';
import { createUserLog } from '../../../lib/api';
import { useSelector } from 'react-redux';

const StackColumn = ({index, column, data, option, tagid}) => {

    const [open, setOpen] = React.useState(false);
    const [tagdata, settagdata] = React.useState('');
    const [log, setLog]= React.useState('');
    const user = useSelector(state => state.nav.user);
    const ppid = useSelector(state => state.header.ppid);
    const electronApp = useSelector(state => state.nav.electronApp);

    const handleOpen = (event, id) => {
        setOpen({...open, [id]: true});
    };

    const handleClose = (id) => {
        settagdata('');
        setOpen({...open, [id]: false});
    };

    const handleSubmit = (event, value, id, min, max) => {
        event.preventDefault();
        if (typeof tagdata === 'undefined' || tagdata === '') {
            setOpen({...open, [id]: false});
        } else {
            var writedata = [{'tag_id': id, 'tag_value': tagdata}];
            socket.emit('write tag', writedata);
            setOpen({...open, [id]: false});
            if (!electronApp) {
                createUserLog({ log }).catch(console.error);
            }
        }
        settagdata('');
    };

    const handleChange = (event, value, id, display_id) => {
        event.preventDefault();
        settagdata(event.target.value);
        if (!electronApp) {
            setLog({
                user_id: user.id,
                powerplant_id: ppid,
                display_id: display_id,
                datetime: new Date().toISOString(),
                data: JSON.stringify({ tag_id: [id] }),
            });
        }
    };

    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            <Segment inverted color='grey'>
                <Grid columns='1' stackable padded style={styles.grid}>
                    <p style={styles.header}>{column[i][0].tag_display_subgroup}</p>
                    {column[i].map(r =>
                        <Grid.Row colums={8} key={r.id} style={styles.row}>
                            <Grid.Column width={10} style={styles.name}>{r.tag_display_name}</Grid.Column>
                            {r.id === 99999 ?
                                <>
                                    <Grid.Column width={4}>
                                    <Button
                                        key = 'button'
                                        type = 'button'
                                        size='tiny'
                                        disabled={electronApp ? false : !isAuthorized(user.hmi_role, r.hmi_security)}
                                        content = {data[r.id]}
                                        onClick ={  () => {setOpen({...open, [r.id]:true})}}/>
                                    <Modal
                                        key = {r.id}
                                        style = {styles.width}
                                        open = {open[r.id]}
                                        onClose={handleClose[r.id]}
                                        onOpen ={handleOpen[r.id]}>
                                        <Modal.Header>Enter Value for {r.name}</Modal.Header>
                                        <Modal.Content>
                                            <form autoComplete='off' onSubmit={(event, value) => handleSubmit(event, value, r.id)}>
                                                <Input focus placeholder='Value' style={styles.input}
                                                       name='Input change'
                                                       label = {r.unit || ""}
                                                       labelPosition='right'
                                                       type='number'
                                                       step ='0.0001'
                                                       size='small'
                                                       min ={r.min}
                                                       max ={r.max}
                                                       onChange={(event, value) => handleChange(event, value, r.id, r.display_id)}
                                                       defaultValue={data[r.id]}
                                                /> {r.unit}
                                            </form>
                                            <Button
                                                key = 'button'
                                                content = 'Close'
                                                color = 'red'
                                                style={{marginLeft: '5px', marginTop: '10px'}}
                                                onClick ={  () => handleClose(r.id)}/>
                                        </Modal.Content>
                                    </Modal>
                                    </Grid.Column>
                                </>
                                :
                                r.tag_display_name.slice(-5) !== 'FAULT' || r.tag_display_name.slice(-7) !== 'CRSWORD'?
                                <Grid.Column width={4} style={styles.name}>{(typeof data !== 'undefined' && data !== null && typeof data[r.id] !== 'undefined') ?  data[r.id].toFixed(3)  : ''}</Grid.Column> : ''

                            }
                            <Grid.Column width={1}>{r.unit}</Grid.Column>
                        </Grid.Row>
                    )}
                </Grid>
            </Segment>
        ))
    ))


    return (
        <Grid.Column key={index} style={{maxWidth: '2000px', padding: '10'}}>
            {gridColumn}
        </Grid.Column>
    );
};

const styles = {
    grid: {
        margin: '0',
        padding: '0',
        marginBottom: '0',
        maxWidth: '340px'
    },
    row: {
        padding: '2px 0'
    },
    name: {
        color: 'yellow',
        fontWeight: 'bold'
    },
    header: {
        marginBottom: '10px',
        marginLeft: '120px',
        fontWeight: 'bold',
        fontSize: '18px'
    },
    width: {
        maxWidth: '400px'
    }
};

export default React.memo(StackColumn);
